import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { DialogService } from 'primeng/dynamicdialog';

import { DateService, FormatService, HelperService, HTTPService, DataService } from 'app/services';
import { MktEmailTemplate } from 'app/modules/app-components/mkt-email-template-dialog/mkt-email-template-dialog.component';
import { MktSMSTemplate } from 'app/modules/app-components/mkt-sms-template-dialog/mkt-sms-template-dialog.component';
import { UpdateContactDialogComponent } from '../update-contact-dialog/update-contact-dialog.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dialog-follow-ups',
  templateUrl: './dialog-follow-ups.component.html',
  styleUrls: ['./dialog-follow-ups.component.scss'],
})
export class DialogFollowUpsComponent implements OnInit, OnDestroy {
  @Input('estimate')
  set setEstimateData(estimate: any) {
    if (estimate && estimate._id) {
      this.orderId = estimate._id;
      this.customerId = estimate.customer && estimate.customer.customerId;
      this.vehicleId = this.getVehicleId(estimate);
      this.getFollowUp();
    }
  }
  @Input('sendEstimate')
  set sendEstimate(sendEstimate: any) {
    if (sendEstimate) {
      this.eligibleFollowUps.forEach((followUp: any) => {
        if (followUp.marketingTemplate && followUp.marketingTemplate.text) {
          followUp.marketingTemplate.text = followUp.marketingTemplate.text.replace(new RegExp(this.helperService.escapeRegex('[estimate_send_date]'), 'g'), sendEstimate);
        }
      });

      this.scheduledCampaignId.forEach((followUp: any) => {
        if (followUp.marketingTemplate && followUp.marketingTemplate.text) {
          followUp.marketingTemplate.text = followUp.marketingTemplate.text.replace(new RegExp(this.helperService.escapeRegex('[estimate_send_date]'), 'g'), sendEstimate);
        }
      });

      this.recommendedFollowUps.forEach((followUp: any) => {
        if (followUp.marketingTemplate && followUp.marketingTemplate.text) {
          followUp.marketingTemplate.text = followUp.marketingTemplate.text.replace(new RegExp(this.helperService.escapeRegex('[estimate_send_date]'), 'g'), sendEstimate);
        }
      });
    }
  }
  @Input() isMarketingOptOutEnabled: boolean = false;

  @Output() appHasFollowUps = new EventEmitter<any>();

  orderId: string = '';
  vehicleId: string = '';
  customerId: string = '';
  customer: any = {};
  isFetchingFollowUps: boolean = false;
  upcomingFollowUps: any[] = [];
  eligibleFollowUps: any[] = [];
  scheduledCampaignId: any[] = [];
  recommendedFollowUps: any[] = [];
  dataServiceSubscription: Subscription;
  isAutomatedFollowUp: boolean = false;
  isAutomatedFollowUpOnByCustomer: boolean = false;
  isAllVisible: any = {
    recommendedFollowUp: true,
    upcomingFollowUp: false,
    eligibleFollowUp: true,
  };
  serverTime: any = Date.now();
  isRecommendedExpanded: boolean = false;
  isEligibleExpanded: boolean = false;
  hasShowRecommended: boolean = true;

  constructor(
    private httpService: HTTPService,
    private dateService: DateService,
    private dialogService: DialogService,
    private helperService: HelperService,
    private formatService: FormatService,
    private dataService: DataService,
  ) {}

  ngOnInit() {
    this.setDataService();
  }

  async getFollowUp(matchId?: any) {
    this.isFetchingFollowUps = true;

    if (!this.customerId || !this.vehicleId || !this.orderId) return;

    if (matchId) {
      this.scheduledCampaignId = this.scheduledCampaignId.filter((id) => id !== matchId);
    }

    try {
      const scheduledCampaignId = [];

      // Fetching upcoming, recommended & eligible follow-ups
      const { campaigns, followUps, customer, serverTime } = await this.httpService.getFollowUps(this.customerId, this.orderId, this.vehicleId, { sortField: 'title', sortOrder: 1 });

      // Setting tenant current time
      this.serverTime = this.dateService.getCurrentDateTimeTz(serverTime);
      this.customer = customer;

      // Formatting & setting data for upcoming follow-ups
      this.setUpcomingFollowUp(followUps, customer);

      // Formatting & setting data for recommended & eligible follow-ups
      let { recommendedFollowUps = [], eligibleFollowUps = [] } = this.formatService.formatOrderFollowUp(campaigns, customer, this.serverTime, this.customer.contactId);

      // Removing the already scheduled follow-ups
      recommendedFollowUps = recommendedFollowUps.filter(({ matchId }) => !scheduledCampaignId.includes(matchId));
      eligibleFollowUps = eligibleFollowUps.filter(({ matchId }) => !scheduledCampaignId.includes(matchId));

      this.setRecommendedFollowUp(recommendedFollowUps, eligibleFollowUps);
      this.appHasFollowUps.emit(!!this.recommendedFollowUps.length || !!this.eligibleFollowUps.length);
    } catch (err) {
      console.log(err);
      this.helperService.showToaster('error', err);
    } finally {
      this.isFetchingFollowUps = false;
    }
  }

  setUpcomingFollowUp(scheduledFollowUps: any[], customer) {
    const { upcomingFollowUps = [], upcomingFollowUpIds = [] } = this.formatService.formatScheduledFollowUp(scheduledFollowUps, customer, this.customer.contactId);
    this.scheduledCampaignId = [...Array.from(new Set([...this.scheduledCampaignId, ...upcomingFollowUpIds]))];
    this.upcomingFollowUps = upcomingFollowUps;
  }

  setRecommendedFollowUp(recommendedFollowUps: any[] = [], eligibleFollowUps: any[] = []) {
    this.recommendedFollowUps = [...recommendedFollowUps.filter(({ matchId }) => !this.scheduledCampaignId.includes(matchId))];
    this.eligibleFollowUps = [...eligibleFollowUps.filter(({ matchId }) => !this.scheduledCampaignId.includes(matchId))];
  }

  openContactUpdateDialog() {
    const ref = this.dialogService.open(UpdateContactDialogComponent, {
      closeOnEscape: false,
      width: '650px',
      styleClass: 'add-dialog add-receipt-modal update-contact-dialog',
      showHeader: false,
      data: {
        contactEntityId: this.customer._id,
        email: this.customer.email,
        phone: this.customer.phone,
        contact: this.customer.contactId,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
      }

      onClose.unsubscribe();
    });
  }

  handleOpenTemplate(marketingTemplate: any) {
    const component = marketingTemplate && marketingTemplate.templateType === 'SMS' ? MktSMSTemplate : MktEmailTemplate;

    this.dialogService.open(component, {
      styleClass: 'add-dialog mkt-email-template-dialog-dialog',
      showHeader: false,
      data: { isOpenedFromCampaign: true, campaignTemplateId: marketingTemplate && marketingTemplate.marketingTemplateId, campaignTemplateText: marketingTemplate.text, isReadOnly: true },
    });
  }

  getVehicleId(estimate: any) {
    if (estimate.vehicle) {
      if (estimate.vehicle.vehicleId && estimate.vehicle.vehicleId._id) {
        return estimate.vehicle.vehicleId._id;
      } else {
        return estimate.vehicle.vehicleId;
      }
    }

    return null;
  }

  setDataService() {
    this.dataServiceSubscription = this.dataService.getData().subscribe(({ data }) => {
      if (data) {
        if (data.key === 'company-appdata-updated') {
          this.setFlaggedData();
          this.dataServiceSubscription.unsubscribe();
        }
      }
    });
    this.setFlaggedData();
  }

  setFlaggedData() {
    this.isAutomatedFollowUpOnByCustomer = this.dataService.isAutomatedFollowUpOnByCustomer;
    this.isAutomatedFollowUp = this.dataService.isAutomatedFollowUpEnabled;

    if (this.isAutomatedFollowUp && this.isAutomatedFollowUpOnByCustomer) {
      this.hasShowRecommended = false;
    }
  }

  ngOnDestroy() {
    if (this.dataServiceSubscription) this.dataServiceSubscription.unsubscribe();
  }
}
